import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import FetchCroppedImages from './FetchCroppedImages';
import { Helmet } from 'react-helmet-async';

const RegenerateBackgrounds = () => {
    const navigate = useNavigate();
    const [imageIds, setImageIds] = useState([]);
    const [loadedImagesCount, setLoadedImagesCount] = useState(0);
    const [totalImagesCount, setTotalImagesCount] = useState(0);
    const [page, setPage] = useState(1);
    const shouldImageCountBeUpdatedRef = useRef(true);
    const [imageCache, setImageCache] = useState({});

    useEffect(() => {
        const fetchImages = async () => {

            try {
                const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/images/cropped-images/${page}`, { withCredentials: true });
                setImageIds(prevIds => {
                    // Create a Set from the existing IDs for efficient lookup
                    const existingIdsSet = new Set(prevIds);
                    // Filter out any IDs that are already in the existingIdsSet
                    const newIds = response.data.imageIds.filter(id => !existingIdsSet.has(id));
                    // Set the LoadingImagesCount only if unique newIds are returned
                    if (shouldImageCountBeUpdatedRef.current) {
                        setLoadedImagesCount(prevCount => prevCount + response.data.imageIds.length);
                        shouldImageCountBeUpdatedRef.current = false;
                    }
                    // Return the new array with duplicates filtered out
                    return [...prevIds, ...newIds];
                });
                setTotalImagesCount(response.data.totalImagesCount);
            } catch (error) {
                console.error('Error fetching generated images:', error);
            }
        };

        fetchImages();
    }, [page]);

    const handleLoadMore = () => {
        setPage(prevPage => prevPage + 1);
        shouldImageCountBeUpdatedRef.current = true;
    }

    // Routes one level back to /account
    const handleBackRequest = () => {
        navigate("/account");
    };

    return (
        <>
            <div className="common-styles">
                <Helmet>
                    <title>generatebg - Regenerate Backgrounds</title>
                    <meta name="description" content="Download matted images or regenerate backgrounds (low-res previews) here." />
                    <link rel="canonical" href={`${process.env.REACT_APP_CLIENT_URL}/account/regenerate-backgrounds`} />
                </Helmet>
                <p className="text-center">
                    <button className="generic-account-button" onClick={handleBackRequest}>Go Back</button>
                </p>
                <h1>Hover Over An Image To Genertate A Background Using It</h1>
                {(
                    /* Pass the imageIds to the FetchGeneratedImages component */
                    imageIds.length > 0 &&
                    <FetchCroppedImages
                        imageCache={imageCache}
                        setImageCache={setImageCache}
                        imageIDs={imageIds}
                    />
                )}
                {(loadedImagesCount < totalImagesCount) && (
                    <button className="generic-account-button--center" onClick={handleLoadMore}>
                        Load More
                    </button>
                )}
            </div>
        </>
    );
};

export default RegenerateBackgrounds;